import { render } from "./PaymentConnectorTransactionNumberForm.vue?vue&type=template&id=9874c448"
import script from "./PaymentConnectorTransactionNumberForm.vue?vue&type=script&lang=js"
export * from "./PaymentConnectorTransactionNumberForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
